import { ColumnType } from "../component/ReadTable/ReadTable"

export const Constants = {
    loggedIn: 'loggedIn',
    nameState: 'nameState',
    rolesState: 'rolesState'
}
export const xhrCall = 'PORTAL.XHR';
export const regSources = ['web', 'photoregister', 'portal', 'crmdb', 'qrcode', 'external', 'd2c']

export const localeList = ['en_US', 'en_CA', 'fr_CA']

export const campaignList = ['localeList', 'DEFAULT']

export const ErrorConstant = {
    error: "Some error occurred!",
    noUserAvailable: "No User available!",
    noRegisteredProductsFound: "No Registered Products found!",
    fetchRegisteredProducts: "Some error occurred while fetching Registered Products!",
    fetchProducts: "Some error occurred while fetching Products!",
    fetchRetailers: "Some error occurred while fetching Retailers!",
    popUpload: "Some error occurred while uploading Proof of Purchase!",
    popDelete: "Some error occurred while deleting Proof of Purchase!",
    fetchCCPADetails: "Some error occurred while fetching CCPA details!",
    updateCampaignDetails: "Some error occurred while Updating Campaign details!",
    fetchCampaignDetails: "Some error occurred while Fetching Campaign details!",
    fetchProductsByCampaign: "Some error occurred while Fetching Products!",
    deleteUser: "Some error occurred while deleting User!",
    generatingCSV: 'Some Error occurred while generating CSV. Please try after sometime.',
    downloadingCSV: "Some error Occurred while downloading CSV!",
    accountTransfer: "Some error occurred during Account transfer!",
    fetchAccountDetails: "Some error occurred during fetching Account Details!",
    noAccountDetails: "No Account Details found!",
    manageRetailer: "Some error occured while Adding/Modifying/Deleting Retailer Information!"
}

export const Warnings = {
    selectOneFilter: 'select at least one search field',
    csvFileSizeExceeded: 'CSV File size exceeded the limit of 1MB',
    csvFileType: 'CSV File type required',
    optimizeSearch: "Please optimize the search selection as the result set has more data or run report from Generate Bulk Report section."
}

export const AppRoutes = {
    registrationSearch: '/registration_search',
    entitlementSearch: '/entitlement_search',
    userInfoSearch: '/user_info_search',
    searchDetails: '/:search/:registration_id/details',
    view_reports: '/view_reports',
    updateProtectionPlan: '/update_protection_plan',
    campaignSetup: '/campaign_setup',
    transferAccount: '/transfer_account',
    generateBulkReport: '/generate_bulk_report',
    viewBulkReport: '/view_bulk_report',
    manageRetailers: '/manage_retailers',
}

export const accountKeys = [
    { key: 'first_name', value: 'First Name' },
    { key: 'last_name', value: 'Last Name' },
    { key: 'email', value: 'Email' },
    { key: 'phone', value: 'Phone' },
    { key: 'city', value: 'City' },
    { key: 'state', value: 'State' },
    { key: 'zipcode', value: 'Zipcode' },
    { key: 'registration_details', value: 'Registration Details' },
]

export const registrationDetailsMinHeader = [
    { key: 'registration_id', value: 'Registration Id' },
    { key: 'model_description', value: 'Product Name' },
    { key: 'registration_serial_number', value: 'Serial Number' },
    { key: 'purchase_date', value: 'Purchase Date', type: ColumnType.date },
    { key: 'registration_date', value: 'Registration Date', type: ColumnType.date },
    { key: 'retailer_name', value: 'Retailer Name' },
    { key: 'date_of_delivery', value: 'Delivery Date', type: ColumnType.date },
]

export const countryOptions = [
    { label: 'US', value: 'us' },
    { label: 'Canada', value: 'ca' }
]

export const stateByCountry = {
    us: [
        {
            label: 'Alabama',
            value: 'AL'
        },
        {
            label: 'Alaska',
            value: 'AK'
        },
        {
            label: 'Arizona',
            value: 'AZ'
        },
        {
            label: 'Arkansas',
            value: 'AR'
        },
        {
            label: 'California',
            value: 'CA'
        },
        {
            label: 'Colorado',
            value: 'CO'
        },
        {
            label: 'Connecticut',
            value: 'CT'
        },
        {
            label: 'Delaware',
            value: 'DE'
        },
        {
            label: 'Florida',
            value: 'FL'
        },
        {
            label: 'Georgia',
            value: 'GA'
        },
        {
            label: 'Hawaii',
            value: 'HI'
        },
        {
            label: 'Idaho',
            value: 'ID'
        },
        {
            label: 'Illinois',
            value: 'IL'
        },
        {
            label: 'Indiana',
            value: 'IN'
        },
        {
            label: 'Iowa',
            value: 'IA'
        },
        {
            label: 'Kansas',
            value: 'KS'
        },
        {
            label: 'Kentucky',
            value: 'KY'
        },
        {
            label: 'Louisiana',
            value: 'LA'
        },
        {
            label: 'Maine',
            value: 'ME'
        },
        {
            label: 'Maryland',
            value: 'MD'
        },
        {
            label: 'Massachusetts',
            value: 'MA'
        },
        {
            label: 'Michigan',
            value: 'MI'
        },
        {
            label: 'Minnesota',
            value: 'MN'
        },
        {
            label: 'Mississippi',
            value: 'MS'
        },
        {
            label: 'Missouri',
            value: 'MO'
        },
        {
            label: 'Montana',
            value: 'MT'
        },
        {
            label: 'Nebraska',
            value: 'NE'
        },
        {
            label: 'Nevada',
            value: 'NV'
        },
        {
            label: 'New Hampshire',
            value: 'NH'
        },
        {
            label: 'New Jersey',
            value: 'NJ'
        },
        {
            label: 'New Mexico',
            value: 'NM'
        },
        {
            label: 'New York',
            value: 'NY'
        },
        {
            label: 'North Carolina',
            value: 'NC'
        },
        {
            label: 'North Dakota',
            value: 'ND'
        },
        {
            label: 'Ohio',
            value: 'OH'
        },
        {
            label: 'Oklahoma',
            value: 'OK'
        },
        {
            label: 'Oregon',
            value: 'OR'
        },
        {
            label: 'Pennsylvania',
            value: 'PA'
        },
        {
            label: 'Rhode Island',
            value: 'RI'
        },
        {
            label: 'South Carolina',
            value: 'SC'
        },
        {
            label: 'South Dakota',
            value: 'SD'
        },
        {
            label: 'Tennessee',
            value: 'TN'
        },
        {
            label: 'Texas',
            value: 'TX'
        },
        {
            label: 'Utah',
            value: 'UT'
        },
        {
            label: 'Vermont',
            value: 'VT'
        },
        {
            label: 'Virginia',
            value: 'VA'
        },
        {
            label: 'Washington',
            value: 'WA'
        },
        {
            label: 'West Virginia',
            value: 'WV'
        },
        {
            label: 'Wisconsin',
            value: 'WI'
        },
        {
            label: 'Wyoming',
            value: 'WY'
        },
    ],
    ca: [
        {
            label: 'Alberta',
            value: 'AB'
        },
        {
            label: 'British Columbia',
            value: 'BC'
        },
        {
            label: 'Manitoba',
            value: 'MB'
        },
        {
            label: 'New Brunswick',
            value: 'NB'
        },
        {
            label: 'Nova Scotia',
            value: 'NS'
        },
        {
            label: 'Newfoundland and Labrador',
            value: 'NL'
        },
        {
            label: 'Northwest Territories',
            value: 'NT'
        },
        {
            label: 'Nunavut',
            value: 'NU'
        },
        {
            label: 'Ontario',
            value: 'ON'
        },
        {
            label: 'Prince Edward Island',
            value: 'PE'
        },
        {
            label: 'Quebec',
            value: 'QC'
        },
        {
            label: 'Saskatchewan',
            value: 'SK'
        },
        {
            label: 'Yukon',
            value: 'YT'
        },
    ]
}